import { useBadgeData } from './useBadgeCounts';

/** Pending level-approval count for the sidebar badge (part of the shared /badge-counts poll). */
export function useStepApprovalCount() {
  return useBadgeData().data?.step_approvals ?? 0;
}
